export default function AppointmentModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const whatsappNumber = "917075659696";
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=Hello%20Dr.%20Dileep%2C%20I%20would%20like%20to%20book%20an%20appointment.`;

  // Redirect immediately on open
  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  onClose();

  return null;
}
